import React from 'react'
import WithClickOutside from 'react-click-outside'
import map from 'lodash/map'
import { GENDER_LABEL } from './constants'
import { GENDER } from '../../../../lib/constants'
import { isAmwellTheme } from '../../../../lib/util'

const grayBorder = '#e8e5e5'
const styles = {
  styledSelect: {
    height: '29px',
    overflow: 'hidden',
    width: '90px',
    WebkitBorderRadius: '5px',
    borderRadius: '5px',
    border: `1px solid ${grayBorder}`
  },
  select: {
    background: 'transparent',
    border: 'none',
    fontSize: '16px',
    height: '29px',
    padding: '5px',
    width: '90px'
  }
}

const stylesDark = {
  styledSelect: {
    height: '29px',
    overflow: 'hidden',
    width: '90px',
    WebkitBorderRadius: '5px',
    borderRadius: '5px',
    border: `1px solid ${grayBorder}`
  },
  select: {
    background: '#fff',
    border: 'none',
    fontSize: '16px',
    height: '29px',
    padding: '5px',
    width: '90px'
  }
}

const GenderPicker = (props) => {
  const isAmwellDark = isAmwellTheme()
  const {
    // onToggle,
    gender,
    handleUpdatePatientGenderCreation
  } = props

  // const handleClickOutside = () => toggle()

  // const toggle = () => onToggle(GENDER_PICKER)

  return (
    <span style={styles.styledSelect}>
      <select
        style={!isAmwellDark ? styles.styledSelect : stylesDark.styledSelect}
        onChange={handleUpdatePatientGenderCreation}
        defaultValue={gender}
      >
        <option disabled selected value={GENDER_LABEL} key={GENDER_LABEL}>{GENDER_LABEL}</option>
        {map(GENDER, val => <option value={val} key={val}>{val}</option>)}
      </select>
    </span>
  )
}

export default WithClickOutside(GenderPicker)
